import { Link, Modal, Spin } from 'lego-on-react';
import * as React from 'react';
import { ReactElement } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { SaveSuccessData } from '../../typings/common';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './FrameEditPopup.css';

type FrameEditPopupProps<T extends SaveSuccessData> = {
    entityType: T['type'];
    children: ReactElement<{ onLoad?: () => void }>;
    onClose: () => void;
    onSaveSuccess: (data: T) => void;
};

interface FrameEditPopupState {
    isLoading: boolean;
}

export class FrameEditPopup<T extends SaveSuccessData> extends React.Component<
    FrameEditPopupProps<T>,
    FrameEditPopupState
> {
    constructor(props: FrameEditPopupProps<T>) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        window.addEventListener('message', this.onFrameSaveSuccess);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onFrameSaveSuccess);
    }

    render() {
        const { isLoading } = this.state;
        const editComponent = this.props.children;

        return (
            <Modal
                view="classic"
                theme="normal"
                zIndexGroupLevel={1}
                visible={true}
            >
                <div
                    className={Bem.cls({
                        block: 'frame-edit-popup',
                        mods: { loaded: !isLoading }
                    })}
                >
                    <div className={Bem.cls('frame-edit-popup', 'paranja')}>
                        <Spin
                            cls={Bem.cls('frame-edit-popup', 'spin')}
                            size="l"
                            progress={isLoading}
                        />
                    </div>
                    <Link
                        cls={Bem.cls('frame-edit-popup', 'close')}
                        theme="pseudo"
                        onClick={this.props.onClose}
                    >
                        <Shape2
                            icon={Shape2Icon.close}
                            width={15}
                            height={15}
                        />
                    </Link>
                    {React.cloneElement(editComponent, {
                        onLoad: this.onFrameLoaded
                    })}
                </div>
            </Modal>
        );
    }

    private onFrameLoaded = () => {
        this.setState({
            isLoading: false
        });
    };

    private onFrameSaveSuccess = (e: MessageEvent) => {
        if (e.data.type === 'dna-save-success') {
            const saveSuccessData: T = {
                type: this.props.entityType,
                ...e.data.data
            };

            this.props.onSaveSuccess(saveSuccessData);
        }
    };
}
